module.exports = __webpack_public_path__ + "static/img/sucaiku.915d49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/sucaiku.png
// module id = 1271
// module chunks = 0